import pino from 'pino'

const initParams = {
  // Datadog reads the log message from `message`, not pino's default `msg`.
  messageKey: 'message',

  formatters: {
    // Datadog's status remapper understands level names and syslog 0-7, but not
    // pino's numeric 10-60 scale, so numeric levels are ingested as `info`.
    level: (label) => ({ level: label }),
  },

  browser: {
    asObject: true,
  },
}

export const logger = pino(initParams)

/**
 * Normalizes a thrown value into Datadog's standard error attributes.
 *
 * Rejected promises can carry anything, not just an Error, so values without
 * the expected shape are stringified rather than logged as empty fields.
 *
 * @param error - The thrown value to normalize.
 * @returns The Datadog error attributes.
 */
export const serializeError = (error) => {
  if (error instanceof Error) {
    return {
      kind: error.name,
      message: error.message,
      stack: error.stack,
    }
  }

  return {
    kind: typeof error,
    message: String(error),
  }
}

export const captureError = (error, context = {}) => {
  const serialized = serializeError(error)

  logger.error({
    error: serialized,
    context,
    message: serialized.message,
  })
}
